import { Brand } from "@omni/types/api/product/bff/shared/brand.model";
import { cn } from "@omni/utils/styles";

import { ConditionalWrapper } from "@/utils/helpers";

type BrandLogoComponentProps = {
    brand: Brand | null;
    brandPagePath?: string | null;
};

const BrandLogoComponent = ({
    brand,
    brandPagePath
}: BrandLogoComponentProps) => {
    if (!brand?.image) {
        return null;
    }

    return (
        <figure
            className={cn("tw:mb-0!")}
            data-test={`brandLogo-figure-${brand.name}`}
        >
            <ConditionalWrapper
                condition={!!brandPagePath}
                wrapper={(children) => (
                    <a
                        href={brandPagePath ?? undefined}
                        title={brand.name}
                    >
                        {children}
                    </a>
                )}
            >
                <img
                    className={cn("tw:max-h-17.5 tw:max-w-37.5")}
                    src={brand.image}
                    alt={brand.name}
                />
            </ConditionalWrapper>
        </figure>
    );
};

export { BrandLogoComponent };
